// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import qs from 'qs'
import router from './router'
import ElementUI from 'element-ui'
import '@/style/elementUI-theme/index.css'



// Vue.prototype.appURL = 'http://127.0.0.1';
Vue.prototype.appURL = 'https://sign3fixs6co2ok2wxeoh.youkenjr.com';

import holidayBatchInsert from "@/components/holiday-batch-insert.vue"
Vue.component('holiday-batch-insert',holidayBatchInsert);


Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(ElementUI);


/*
日期格式化，调用示例：
dateFormat("YYYY-mm-dd HH:MM", date)
>>> 2020-06-06 19:45`
*/
Vue.prototype.dateFormat = function(fmt, date){
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}

//获取本月第一天
Vue.prototype.getFirstDayOfMonth = function(){
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return this.dateFormat("YYYY-mm-dd", firstDay);
}
//获取本月最后一天
Vue.prototype.getEndDayOfMonth = function(){
  var date = new Date();
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return this.dateFormat("YYYY-mm-dd", lastDay);
}

//计算两个日期之间相差的天数
Vue.prototype.getDaysBetween = function(dateString1,dateString2){
   var  startDate = Date.parse(dateString1);
   var  endDate = Date.parse(dateString2);
   var days=(endDate - startDate)/(1*24*60*60*1000);
   return  days;
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js